// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SuccessScreenTemplate_buttonContainer__fbber","container":"SuccessScreenTemplate_container__+7zw7"};